//GLOBAL - components from npm
import React, { useEffect, useRef, useState } from "react";

// HOOKS

//STYLES
import "./main.css";

//COMPONENTS
import Typography from "../../Typography";

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
// import { ReactComponent as IconClose } from "../../../build/images/icons/CloseIcon.svg";
import { ReactComponent as IconClose } from "../../../build/images/closecircle22px.svg";

export default function Main({
  title = "Drawer Title",
  className = "",
  isOpen,
  onClose = () => null,
  headerContent,
  children,
  footerContent,
  darkMode,
  id = "main-drawer-default-id",
}) {
  //GENERAL
  const drawerRef = useRef();

  //STATES
  const [isVisible, setIsVisible] = useState(false);

  // CUSTOM HOOKS
  // useOutsideClick(drawerRef, () => {
  //     if (isOpen) {
  //         setIsVisible(false)
  //         setTimeout(() => onClose(), 500)
  //     }
  // })

  //REDUX - Selectors

  //USE EFFECTS
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  //FUNCTIONS
  const setCloseDrawer = () => {
    setIsVisible(false);
    onClose();
    // setTimeout(() => onClose(), 500);
  };

  // if (isOpen) {
  return (
    <div id={id} className={`drawer ${isOpen ? "drawer-visible" : ""}`}>
      <div
        className={`drawer__div ${
          isOpen ? "drawer-div-visible" : ""
        } ${className} ${darkMode ? "dark-mode" : ""}`}
        ref={drawerRef}
      >
        <header className="drawer__div__header">
          <div className="drawer__div__header__title">
            {/* <div className="drawer__div__clickable">
                                <ArrowBack onClick={() => setCloseDrawer()} />
                            </div> */}

            <Typography.H2
              color="blue-selected-4"
              weight={700}
              className="color-gray-900"
            >
              {title}
            </Typography.H2>
            <div style={{ height: "100%" }} onClick={() => setCloseDrawer()}>
              <IconClose />
            </div>
          </div>
          {headerContent ? headerContent : ""}
        </header>

        <div className="drawer__div__content">{children}</div>

        {footerContent ? (
          <footer className="drawer__div__footer">{footerContent}</footer>
        ) : (
          ""
        )}
      </div>
    </div>
  );
  // } else {
  //   return "";
  // }
}
